const func = require( '../function.js' );

$(function(){

  // バリデーション
  var form_valid = {
    category: {
      category_ids: false,
    },
    ac_count: {
      ac_count: true,
    },
    toilet_count: {
      toilet_count: true,
    },
    vancancy: {
      vancancy: true,
    },
    layout: {
      layout_id: true,
    },
    parking: {
      parking: false,
    },
    address: {
      zipcode: false,
      prefecture_id: false,
      city_cd: false,
      area_id: false,
      address: false,
    },
    username: {
      person_type: true,
      username_sei: false,
      username_mei: false,
      userkana_sei: false,
      userkana_mei: false,
      company_name: true,
    },
    tel: {
      tel: false,
    },
    email: {
      email: true,
    },
  }

  $(document).ready(function(){
    if ($('[name="agreement"]').length){
      form_valid.agreement = { agreement: false }
    }
  });

  $('[name="agreement"]').on('change', function(){
    if ($(this).is(':checked')){
      form_valid.agreement.agreement = true;
    } else {
      form_valid.agreement.agreement = false;
    }
    check_input();
  });

  var check_address_block = function() {
    // 都道府県チェック
    if ( $( '[name="enduser[prefecture_id]"] option:selected' ).val() != "" ){
      form_valid.address.prefecture_id = true;
      $( '[name="enduser[prefecture_id]"]' ).closest( '.form-valid' ).removeClass( 'form-valid__error' ).addClass( 'form-valid__success' );
      $( '[name="enduser[prefecture_id]"]' ).closest( '.form-valid' ).find( '.form-error' ).remove();
    } else {
      form_valid.address.prefecture_id = false;
      $( '[name="enduser[prefecture_id]"]' ).closest( '.form-valid' ).addClass( 'form-valid__error' ).removeClass( 'form-valid__success' );
      $( '[name="enduser[prefecture_id]"]' ).closest( '.form-valid' ).append( '<p class="form-error">選択してください。</p>' );
    }

    //市区町村チェック
    if ( $( '[name="enduser[city_cd]"] option:selected' ).val() != "" ){
      form_valid.address.city_cd = true;
      $( '[name="enduser[city_cd]"]' ).closest( '.form-valid' ).removeClass( 'form-valid__error' ).addClass( 'form-valid__success' );
      $( '[name="enduser[city_cd]"]' ).closest( '.form-valid' ).find( '.form-error' ).remove();
    } else {
      form_valid.address.city_cd = false;
      $( '[name="enduser[city_cd]"]' ).closest( '.form-valid' ).addClass( 'form-valid__error' ).removeClass( 'form-valid__success' );
      $( '[name="enduser[city_cd]"]' ).closest( '.form-valid' ).append( '<p class="form-error">選択してください。</p>' );
    }

    //町名
    if ( $( '[name="enduser[area_id]"] option:selected' ).val() != "" ){
      form_valid.address.area_id = true;
      $( '[name="enduser[area_id]"]' ).closest( '.form-valid' ).removeClass( 'form-valid__error' ).addClass( 'form-valid__success' );
      $( '[name="enduser[area_id]"]' ).closest( '.form-valid' ).find( '.form-error' ).remove();
    } else {
      form_valid.address.area_id = false;
      $( '[name="enduser[area_id]"]' ).closest( '.form-valid' ).addClass( 'form-valid__error' ).removeClass( 'form-valid__success' );
      $( '[name="enduser[area_id]"]' ).closest( '.form-valid' ).append( '<p class="form-error">選択してください。</p>' );
    }

    //郵便番号
    if ( $( '[name="enduser[zipcode]"]' ).val() != "" && $( '[name="enduser[zipcode]"]' ).val().length == 7 ) {
      form_valid.address.zipcode = true;
      $( '[name="enduser[zipcode]"]' ).closest( '.form-valid' ).removeClass( 'form-valid__error' ).addClass( 'form-valid__success' );
      $( '[name="enduser[zipcode]"]' ).closest( '.form-valid' ).find( '.form-error' ).remove();
    } else {
      form_valid.address.zipcode = false;
      $( '[name="enduser[zipcode]"]' ).closest( '.form-valid' ).addClass( 'form-valid__error' ).removeClass( 'form-valid__success' );
      $( '[name="enduser[zipcode]"]' ).closest( '.form-valid' ).append( '<p class="form-error">選択してください。</p>' );
    }

    //番地以降
    if( $( '[name="enduser[address]"]' ).val() != "" ){
      form_valid.address.address = true;
      $( '[name="enduser[address]"]' ).closest( '.form-valid' ).removeClass( 'form-valid__error' ).addClass( 'form-valid__success' );
      $( '[name="enduser[address]"]' ).closest( '.form-valid' ).find( '.form-error' ).remove();
    } else {
      form_valid.address.address = false;
      $( '[name="enduser[address]"]' ).closest( '.form-valid' ).addClass( 'form-valid__error' ).removeClass( 'form-valid__success' );
      $( '[name="enduser[address]"]' ).closest( '.form-valid' ).append( '<p class="form-error">選択してください。</p>' );
    }

    var check_result = Object.keys( form_valid.address ).every( function( key ) {
       return form_valid.address[key];
    });

    return check_result;
  };

  var check_username_block = function() {
    // ユーザー種別
    if ( $( '[name="enduser[person_type]"]:checked' ).val() == 1 ){
      form_valid.username.company_name = true;
      $( '[name="enduser[company_name]"]' ).closest( '.form-valid' ).removeClass( 'form-valid__error' ).addClass( 'form-valid__success' );
      $( '[name="enduser[company_name]"]' ).closest( '.form-valid' ).find( '.form-error' ).remove();
      $( '[name="enduser[company_name]"]' ).val('');
      $( '#box_company_name:visible' ).slideUp( 'fast' );
    } else if ( $( '[name="enduser[person_type]"]:checked' ).val() == 2 ) {
      form_valid.username.company_name = false;
      $( '[name="enduser[company_name]"]' ).closest( '.form-valid' ).removeClass( 'form-valid__error' ).addClass( 'form-valid__success' );
      $( '[name="enduser[company_name]"]' ).closest( '.form-valid' ).find( '.form-error' ).remove();
      $( '#box_company_name:hidden' ).slideDown( 'fast' );
    }

    // 会社名
    if ( $( '[name="enduser[person_type]"]:checked' ).val() == 2 ) {
      if ( $( '[name="enduser[company_name]"]' ).val() != ""  ){
        form_valid.username.company_name = true;
        $( '[name="enduser[company_name]"]' ).closest( '.form-valid' ).removeClass( 'form-valid__error' ).addClass( 'form-valid__success' );
        $( '[name="enduser[company_name]"]' ).closest( '.form-valid' ).find( '.form-error' ).remove();
      } else {
        form_valid.username.company_name = false;
        $( '[name="enduser[company_name]"]' ).closest( '.form-valid' ).addClass( 'form-valid__error' ).removeClass( 'form-valid__success' );
        $( '[name="enduser[company_name]"]' ).closest( '.form-valid' ).append( '<p class="form-error">入力してください。</p>' );
      }
    }

    // 姓
    if ( $( '[name="enduser[username_sei]"]' ).val() != "" ){
      form_valid.username.username_sei = true;
      $( '[name="enduser[username_sei]"]' ).closest( '.form-valid' ).removeClass( 'form-valid__error' ).addClass( 'form-valid__success' );
      $( '[name="enduser[username_sei]"]' ).closest( '.form-valid' ).find( '.form-error' ).remove();
    } else {
      form_valid.username.username_sei = false;
      $( '[name="enduser[username_sei]"]' ).closest( '.form-valid' ).addClass( 'form-valid__error' ).removeClass( 'form-valid__success' );
      $( '[name="enduser[username_sei]"]' ).closest( '.form-valid' ).append( '<p class="form-error">入力してください。</p>' );
    }

    //名
    if ( $( '[name="enduser[username_mei]"]' ).val() != "" ){
      form_valid.username.username_mei = true;
      $( '[name="enduser[username_mei]"]' ).closest( '.form-valid' ).removeClass( 'form-valid__error' ).addClass( 'form-valid__success' );
      $( '[name="enduser[username_mei]"]' ).closest( '.form-valid' ).find( '.form-error' ).remove();
    } else {
      form_valid.username.username_mei = false;
      $( '[name="enduser[username_mei]"]' ).closest( '.form-valid' ).addClass( 'form-valid__error' ).removeClass( 'form-valid__success' );
      $( '[name="enduser[username_mei]"]' ).closest( '.form-valid' ).append( '<p class="form-error">入力してください。</p>' );
    }

    //セイ
    if ( $( '[name="enduser[userkana_sei]"]' ).val() != "" && func.is_kana( $( '[name="enduser[userkana_sei]"]' ).val() ) ){
      form_valid.username.userkana_sei = true;
      $( '[name="enduser[userkana_sei]"]' ).closest( '.form-valid' ).removeClass( 'form-valid__error' ).addClass( 'form-valid__success' );
      $( '[name="enduser[userkana_sei]"]' ).closest( '.form-valid' ).find( '.form-error' ).remove();
    } else {
      form_valid.username.userkana_sei = false;
      $( '[name="enduser[userkana_sei]"]' ).closest( '.form-valid' ).addClass( 'form-valid__error' ).removeClass( 'form-valid__success' );
      $( '[name="enduser[userkana_sei]"]' ).closest( '.form-valid' ).append( '<p class="form-error">入力してください。</p>' );
    }

    //メイ
    if ( $( '[name="enduser[userkana_mei]"]' ).val() != "" && func.is_kana( $( '[name="enduser[userkana_mei]"]' ).val() ) ) {
      form_valid.username.userkana_mei = true;
      $( '[name="enduser[userkana_mei]"]' ).closest( '.form-valid' ).removeClass( 'form-valid__error' ).addClass( 'form-valid__success' );
      $( '[name="enduser[userkana_mei]"]' ).closest( '.form-valid' ).find( '.form-error' ).remove();
    } else {
      form_valid.username.userkana_mei = false;
      $( '[name="enduser[userkana_mei]"]' ).closest( '.form-valid' ).addClass( 'form-valid__error' ).removeClass( 'form-valid__success' );
      $( '[name="enduser[userkana_mei]"]' ).closest( '.form-valid' ).append( '<p class="form-error">入力してください。</p>' );
    }

    var check_result = Object.keys( form_valid.username ).every( function( key ) {
       return form_valid.username[key];
    });

    return check_result;
  };

  var check_input = function() {
    var flg_arr = [];
    $.each( form_valid, function( name, hash ){
      flg_arr.push( Object.keys( hash ).every( function( key ) {
        return hash[key];
      }));
    });

    var result = $.inArray( false, flg_arr ) > -1;
    
    $( '#user_conversion [type="submit"]' ).prop( 'disabled', result );
    if ( ! result ) {
      var scroll = $( '#user_conversion [type="submit"]' ).offset().top - $( '#row_tel' ).outerHeight() - $( '#row_email' ).outerHeight();
      $( 'html, body' ).animate({scrollTop: scroll}, 300, 'swing' );
    }
  };

  // サブミット時にボタンをdisableにする
  $( '#user_conversion' ).submit(function(){
    $( '#user_conversion [type="submit"]' ).prop( 'disabled', true );
    $( '#user_conversion input, #user_conversion select' ).prop( 'readonly', true );
  });
  
  // まとめてチェックボタン
  $( '[name="all_check"]' ).change(function(){
    if( $( this ).prop('checked') == true ) {
      $( '[name="enduser[category_ids][]"]').prop( "checked",true );
      $( this ).next( '.form__allbtn-txt' ).text( 'チェックを外す' );

      form_valid.category.category_ids = true;
      $( '#row_vancancy:hidden' ).slideDown('fast');
      $( '.form-checkbox__img' ).removeClass( 'not-checked' );

      if($('[name="enduser[ac_count]"] option:selected').val() == ""){
        form_valid.ac_count.ac_count = false;
        $('[name="enduser[ac_count]"]').closest('.form-valid').removeClass('form-valid__success');
      }
      $( '#row_ac_count:hidden' ).slideDown('fast');

      if ($('[name="enduser[toilet_count]"] option:selected').val() == ""){
        form_valid.toilet_count.toilet_count = false;
        $('[name="enduser[toilet_count]"]').closest('.form-valid').removeClass('form-valid__success');
      }
      $( '#row_toilet_count:hidden' ).slideDown('fast');

    } else {
      $( '[name="enduser[category_ids][]"]').prop( "checked",false );
      $( this ).next( '.form__allbtn-txt' ).html( '<i class="fa fa-check"></i>まとめて選択（無料）' );

      form_valid.category.category_ids = false;
      $( '.form-checkbox__img' ).addClass( 'not-checked' );

      form_valid.ac_count.ac_count = true;
      $( '#row_ac_count:visible' ).slideUp('fast');
      $( '[name="enduser[ac_count]"]' ).val('');

      form_valid.toilet_count.toilet_count = true;
      $( '#row_toilet_count:visible' ).slideUp('fast');
      $( '[name="enduser[toilet_count]"]' ).val('');
    }

    check_input();
  });

  //清掃箇所
  $( '[name="enduser[category_ids][]"]' ).change( function(){
    if( $( '[name="enduser[category_ids][]"]:checked' ).length > 0 ){
      form_valid.category.category_ids = true;
      $( '#row_vancancy:hidden' ).slideDown('fast');
      $( '.form-checkbox__img' ).removeClass( 'not-checked' );
    } else {
      form_valid.category.category_ids = false;
      $( '.form-checkbox__img' ).addClass( 'not-checked' );
    }

    //エアコンがチェックされてる時
    if ( $( '[name="enduser[category_ids][]"][value="2"]:checked' ).length > 0 ) {
      if ($('[name="enduser[ac_count]"] option:selected').val() == "") {
        form_valid.ac_count.ac_count = false;
      }
        $('#row_ac_count:hidden').slideDown('fast');
    } else {
      form_valid.ac_count.ac_count = true;
      $( '#row_ac_count:visible' ).slideUp('fast');
      $( '[name="enduser[ac_count]"]' ).val('');
      $('[name="enduser[ac_count]"]').closest('.form-valid').removeClass('form-valid__success');
    }

    //トイレがチェックされてる時
    if ( $( '[name="enduser[category_ids][]"][value="7"]:checked' ).length > 0 ) {
      if ($('[name="enduser[toilet_count]"] option:selected').val() == ""){
        form_valid.toilet_count.toilet_count = false;
      }
      $( '#row_toilet_count:hidden' ).slideDown('fast');
    } else {
      form_valid.toilet_count.toilet_count = true;
      $( '#row_toilet_count:visible' ).slideUp('fast');
      $( '[name="enduser[toilet_count]"]' ).val('');
      $('[name="enduser[toilet_count]"]').closest('.form-valid').removeClass('form-valid__success');
    }
    check_input();
  });

  // 空室
  $( '[name="enduser[vancancy]"]' ).change( function(){
    console.log( convertStrToBool( $( '[name="enduser[vancancy]"]:checked' ).val() ) );
    if( convertStrToBool(  $( '[name="enduser[vancancy]"]:checked' ).val() ) ){
      form_valid.layout.layout_id = false;
      $( '#row_layout:hidden' ).slideDown('fast');
    } else {
      form_valid.layout.layout_id = true;
      $( '#row_layout:visible' ).slideUp('fast');
      $( '[name="enduser[layout_id]"] option:selected' ).attr( 'selected', false );
    }
    $( '#row_parking:hidden' ).slideDown('fast');
    check_input();
  });

  //間取り（空室を選んだ時のみ）
  $( '[name="enduser[layout_id]"]' ).change( function(){
    if( $( '[name="enduser[layout_id]"] option:selected' ).val() != "" ){
      form_valid.layout.layout_id = true;
      $( '[name="enduser[layout_id]"]' ).closest( '.form-valid' ).removeClass( 'form-valid__error' ).addClass( 'form-valid__success' );
      $( '[name="enduser[layout_id]"]' ).closest( '.form-valid' ).find( '.form-error' ).remove();
    } else {
      form_valid.layout.layout_id = false;
      $( '[name="enduser[layout_id]"]' ).closest( '.form-valid' ).addClass( 'form-valid__error' ).removeClass( 'form-valid__success' );
      $( '[name="enduser[layout_id]"]' ).closest( '.form-valid' ).append( '<p class="form-error">選択してください。</p>' );
    }
    check_input();
  });

  //エアコンの台数（エアコンを選んだ時のみ）
  $( '[name="enduser[ac_count]"]' ).change( function(){
    if( $( '[name="enduser[ac_count]"] option:selected' ).val() != "" ){
      form_valid.ac_count.ac_count = true;
      $( '[name="enduser[ac_count]"]' ).closest( '.form-valid' ).removeClass( 'form-valid__error' ).addClass( 'form-valid__success' );
      $( '[name="enduser[ac_count]"]' ).closest( '.form-valid' ).find( '.form-error' ).remove();
    } else {
      form_valid.ac_count.ac_count = false;
      $( '[name="enduser[ac_count]"]' ).closest( '.form-valid' ).addClass( 'form-valid__error' ).removeClass( 'form-valid__success' );
      $( '[name="enduser[ac_count]"]' ).closest( '.form-valid' ).append( '<p class="form-error">選択してください。</p>' );
    }
    check_input();
  });

  //トイレの台数（エアコンを選んだ時のみ）
  $( '[name="enduser[toilet_count]"]' ).change( function(){
    if( $( '[name="enduser[toilet_count]"] option:selected' ).val() != "" ){
      form_valid.toilet_count.toilet_count = true;
      $( '[name="enduser[toilet_count]"]' ).closest( '.form-valid' ).removeClass( 'form-valid__error' ).addClass( 'form-valid__success' );
      $( '[name="enduser[toilet_count]"]' ).closest( '.form-valid' ).find( '.form-error' ).remove();
    } else {
      form_valid.toilet_count.toilet_count = false;
      $( '[name="enduser[toilet_count]"]' ).closest( '.form-valid' ).addClass( 'form-valid__error' ).removeClass( 'form-valid__success' );
      $( '[name="enduser[toilet_count]"]' ).closest( '.form-valid' ).append( '<p class="form-error">選択してください。</p>' );
    }
    check_input();
  });

  //建物の種類
  $( '[name="enduser[parking]"]' ).change( function(){
    if( $( '[name="enduser[parking]"] option:selected' ).val() != "" ){
      form_valid.parking.parking = true;
      $( '[name="enduser[parking]"]' ).closest( '.form-valid' ).removeClass( 'form-valid__error' ).addClass( 'form-valid__success' );
      $( '[name="enduser[parking]"]' ).closest( '.form-valid' ).find( '.form-error' ).remove();
      $( '#row_address:hidden' ).slideDown('fast');
      var scroll = $( '#row_address' ).offset().top - $( this ).closest( '.form__row' ).prev( '.form__row' ).outerHeight();
      $( 'html, body' ).animate({scrollTop: scroll}, 300, 'swing' );
    } else {
      form_valid.parking.parking = false;
      $( '[name="enduser[parking]"]' ).closest( '.form-valid' ).addClass( 'form-valid__error' ).removeClass( 'form-valid__success' );
      $( '[name="enduser[parking]"]' ).closest( '.form-valid' ).append( '<p class="form-error">選択してください。</p>' );
    }
    check_input();
  });

  //郵便番号
  $( '[name="enduser[zipcode]"]' ).blur( function(){
    if ( check_address_block() ) {
      $( '#row_username:hidden' ).slideDown('fast');
      var scroll = $( '#row_username' ).offset().top - $( this ).closest( '.form__row' ).prev( '.form__row' ).outerHeight();
      $( 'html, body' ).animate({scrollTop: scroll}, 300, 'swing' );
    }
    check_input();
  });

  // 都道府県
  $( '[name="enduser[prefecture_id]"]' ).change( function(){
    if ( check_address_block() ) {
      $( '#row_username:hidden' ).slideDown('fast');
      var scroll = $( '#row_username' ).offset().top - $( this ).closest( '.form__row' ).prev( '.form__row' ).outerHeight();
      $( 'html, body' ).animate({scrollTop: scroll}, 300, 'swing' );
    }
    check_input();
  });

  // 市区町村
  $( '[name="enduser[city_cd]"]' ).change( function(){
    if ( check_address_block() ) {
      $( '#row_username:hidden' ).slideDown('fast');
      var scroll = $( '#row_username' ).offset().top - $( this ).closest( '.form__row' ).prev( '.form__row' ).outerHeight();
      $( 'html, body' ).animate({scrollTop: scroll}, 300, 'swing' );
    }
    check_input();
  });

  // 町名
  $( '[name="enduser[area_id]"]' ).change( function(){
    if ( check_address_block() ) {
      $( '#row_username:hidden' ).slideDown('fast');
      var scroll = $( '#row_username' ).offset().top - $( this ).closest( '.form__row' ).prev( '.form__row' ).outerHeight();
      $( 'html, body' ).animate({scrollTop: scroll}, 300, 'swing' );
    }
    check_input();
  });

  //番地以降
  $( '[name="enduser[address]"]' ).blur( function(){
    if ( check_address_block() ) {
      $( '#row_username:hidden' ).slideDown('fast');
      var scroll = $( '#row_username' ).offset().top - $( this ).closest( '.form__row' ).prev( '.form__row' ).outerHeight();
      $( 'html, body' ).animate({scrollTop: scroll}, 300, 'swing' );
    }
    check_input();
  });

  //姓
  $( '[name="enduser[person_type]"]' ).change( function(){
    if ( check_username_block() ) {
      $( '#row_tel:hidden' ).slideDown('fast');
      $( '#row_email:hidden' ).slideDown('fast');
      var scroll = $( '#row_tel' ).offset().top - $( this ).closest( '.form__row' ).prev( '.form__row' ).outerHeight();
      $( 'html, body' ).animate({scrollTop: scroll}, 300, 'swing' );
    }
    check_input();
  });

  //姓
  $( '[name="enduser[username_sei]"]' ).blur( function(){
    if ( check_username_block() ) {
      $( '#row_tel:hidden' ).slideDown('fast');
      $( '#row_email:hidden' ).slideDown('fast');
      var scroll = $( '#row_tel' ).offset().top - $( this ).closest( '.form__row' ).prev( '.form__row' ).outerHeight();
      $( 'html, body' ).animate({scrollTop: scroll}, 300, 'swing' );
    }
    check_input();
  });

  //名
  $( '[name="enduser[username_mei]"]' ).blur( function(){
    if ( check_username_block() ) {
      $( '#row_tel:hidden' ).slideDown('fast');
      $( '#row_email:hidden' ).slideDown('fast');
      var scroll = $( '#row_tel' ).offset().top - $( this ).closest( '.form__row' ).prev( '.form__row' ).outerHeight();
      $( 'html, body' ).animate({scrollTop: scroll}, 300, 'swing' );
    }
    check_input();
  });

  //セイ
  $( '[name="enduser[userkana_sei]"]' ).blur( function(){
    if ( check_username_block() ) {
      $( '#row_tel:hidden' ).slideDown('fast');
      $( '#row_email:hidden' ).slideDown('fast');
      var scroll = $( '#row_tel' ).offset().top - $( this ).closest( '.form__row' ).prev( '.form__row' ).outerHeight();
      $( 'html, body' ).animate({scrollTop: scroll}, 300, 'swing' );
    }
    check_input();
  });

  //メイ
  $( '[name="enduser[userkana_mei]"]' ).blur( function(){
    if ( check_username_block() ) {
      $( '#row_tel:hidden' ).slideDown('fast');
      $( '#row_email:hidden' ).slideDown('fast');
      var scroll = $( '#row_tel' ).offset().top - $( this ).closest( '.form__row' ).prev( '.form__row' ).outerHeight();
      $( 'html, body' ).animate({scrollTop: scroll}, 300, 'swing' );
    }
    check_input();
  });

  //会社名
  $( '[name="enduser[company_name]"]' ).blur( function(){
    if ( check_username_block() ) {
      $( '#row_tel:hidden' ).slideDown('fast');
      $( '#row_email:hidden' ).slideDown('fast');
      var scroll = $( '#row_tel' ).offset().top - $( this ).closest( '.form__row' ).prev( '.form__row' ).outerHeight();
      $( 'html, body' ).animate({scrollTop: scroll}, 300, 'swing' );
    }
    check_input();
  });

  //電話番号
  $( '[name="enduser[tel]"]' ).blur( function(){
    if( $( '[name="enduser[tel]"]' ).val() != "" && func.is_tel( $( '[name="enduser[tel]"]' ).val() ) ){
      form_valid.tel.tel = true;
      $( '[name="enduser[tel]"]' ).closest( '.form-valid' ).removeClass( 'form-valid__error' ).addClass( 'form-valid__success' );
      $( '[name="enduser[tel]"]' ).closest( '.form-valid' ).find( '.form-error' ).remove();
      $( '.cBtn-beneath' ).slideDown('fast');
    } else {
      form_valid.tel.tel = false;
      $( '[name="enduser[tel]"]' ).closest( '.form-valid' ).addClass( 'form-valid__error' ).removeClass( 'form-valid__success' );
      $( '[name="enduser[tel]"]' ).closest( '.form-valid' ).append( '<p class="form-error">入力してください。</p>' );
      $( '.cBtn-beneath' ).slideUp();
    }
    check_input();
  });

  //メールアドレス
  $( '[name="enduser[email]"]' ).blur( function(){
    if( $( '[name="enduser[email]"]' ).val() != "" && func.is_email( $( '[name="enduser[email]"]' ).val() ) ){
      form_valid.email.email = true;
      $( '[name="enduser[email]"]' ).closest( '.form-valid' ).removeClass( 'form-valid__error' ).addClass( 'form-valid__success' );
      $( '[name="enduser[email]"]' ).closest( '.form-valid' ).find( '.form-error' ).remove();
    } else if ( $( '[name="enduser[email]"]' ).val() == "" ) {
      form_valid.email.email = true;
      $( '[name="enduser[email]"]' ).closest( '.form-valid' ).removeClass( 'form-valid__error' ).removeClass( 'form-valid__success' );
      $( '[name="enduser[email]"]' ).closest( '.form-valid' ).find( '.form-error' ).remove();
    } else {
      form_valid.email.email = false;
      $( '[name="enduser[email]"]' ).closest( '.form-valid' ).addClass( 'form-valid__error' ).removeClass( 'form-valid__success' );
      $( '[name="enduser[email]"]' ).closest( '.form-valid' ).append( '<p class="form-error">入力してください。</p>' );
    }
    check_input();
  });

  function convertStrToBool(str){
    if(typeof str != 'string'){ 
      return Boolean(str); 
    }
    try{
      var obj = JSON.parse(str.toLowerCase());
      return obj == true;
    }catch(e){
      return str != '';
    }
  }

});


//////////////////
// WEBPACK FOOTER
// ./app/assets/javascripts/form/validation.js
// module id = 6
// module chunks = 0 1